import React from 'react';
import { Text } from '@newcore/ui/typography';

interface EmptyStateProps {
  message: string | string[];
  className?: string;
}

export const EmptyState = React.memo(
  ({ message, className }: EmptyStateProps) => {
    const messages = Array.isArray(message) ? message : [message];

    return (
      <div
        className={`w-full flex flex-col items-center justify-start py-8 px-4 ${className ?? ''}`}
      >
        <div className='max-w-md w-full space-y-1 text-center'>
          {messages.map(line => (
            <Text as='p' key={line} className='text-tertiary'>
              {line}
            </Text>
          ))}
        </div>
      </div>
    );
  }
);

EmptyState.displayName = 'EmptyState';
